import { render, staticRenderFns } from "./Containers.vue?vue&type=template&id=0508b3c4&scoped=true&"
import script from "./Containers.vue?vue&type=script&lang=js&"
export * from "./Containers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0508b3c4",
  null
  
)

export default component.exports